function purePath(path) {
  if (typeof path !== 'string' || !path) return ''
  return path.split('?')[0].split('#')[0]
}

export function isCheckinPath(path) {
  const pure = purePath(path)
  return pure.startsWith('/checkin/')
}

function isVoteRedirectPath(path) {
  const pure = purePath(path)
  return pure === '/vote-success' || pure.startsWith('/vote/')
}

/** 投票/签到扫码进入：仅允许手机号验证码登录 */
export function isSmsLoginMeta(meta) {
  return !!(meta && (meta.smsLogin || meta.voteFlow))
}

export function isSmsOnlyLogin(query, redirectPath) {
  const flag = query && (query.smsLogin != null ? query.smsLogin : query.voteLogin)
  if (flag === '1' || flag === 1) return true
  return isVoteRedirectPath(redirectPath) || isCheckinPath(redirectPath)
}

/** 安全的站内回跳地址（投票进投票、签到进签到） */
export function resolveSafeRedirect(redirect) {
  if (typeof redirect !== 'string' || !redirect) return ''
  let path = redirect.trim()
  if (path.startsWith('#')) path = path.slice(1)
  try {
    path = decodeURIComponent(path)
  } catch (e) {
    // 保持原值
  }
  if (!path.startsWith('/') || path.startsWith('//')) return ''
  return path
}

/** 未登录跳转登录页时的 query：带回原页面，并标记验证码登录 */
export function buildLoginRedirectQuery(fullPath, meta) {
  const query = {}
  const redirect = resolveSafeRedirect(fullPath)
  if (redirect) query.redirect = redirect
  if (isSmsLoginMeta(meta) || isSmsOnlyLogin(null, redirect || fullPath)) {
    query.smsLogin = '1'
  }
  return query
}
